import { OrderAttempt, adoptOrderAttempt, endOrderAttempt } from './orderAttempt'
import { useEffect, useState } from 'react'
import { OrderLaunchedFrom } from 'models/purchaseFlow/orderLaunchedFrom'

/**
 * One order attempt per purchase-flow mount: adopted from the click that started it, else minted with the surface's
 * fallback entry point. The id is a Mixpanel super property for the attempt's events; id and entry point go with
 * placeOrder so the server-side purchase carries both. Ended on unmount: post-order surfaces anchor on orderId.
 */
export const useOrderAttempt = (fallbackLaunchedFrom: OrderLaunchedFrom): OrderAttempt => {
  // Registered at adoption, during render, not in an effect: React runs descendant effects before this
  // provider's, so the first order_flow_loaded of the attempt would otherwise fire without the id.
  const [attempt] = useState(() => adoptOrderAttempt(fallbackLaunchedFrom))

  useEffect(() => () => endOrderAttempt(attempt.orderAttemptId), [attempt.orderAttemptId])

  return attempt
}
